import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const LoginCallbackPage = withSuspense(
	lazy(() => import('./login-callback-page.component')),
	PageLoader,
);
